var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-bottom-pad",class:{ 'is-tab-page': _vm.isTabPage }})
}
var staticRenderFns = []

export { render, staticRenderFns }